import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { BaseSyncEvent } from '../../../../models/baseSync.types';
import { useBroadcastMessage } from '../../../../hooks/useBroadcastMessage/useBroadcastMessage';
import { useCallback, useEffect, useRef } from 'react';
import { useOnBroadcastMessage } from '../../../../hooks/useOnBroadcastMessage/useOnBroadcastMessage';
import { mailboxActions } from '../../../../reducers/mailboxReducer/mailboxSlice';
export type MessagesReadSyncEvent = BaseSyncEvent;

const MessagesReadSyncId = 'ONE-MessagesReadSyncId';

export const useMailMenuSync = () => {
  const dispatch = useDispatch();
  const anyUnreadMessagesFound = useSelector((state: RootState) => state.mailbox.anyUnreadMessagesFound);
  const prevAnyUnreadMessagesFound = useRef<boolean>(anyUnreadMessagesFound);

  // We need to cast to any since we are using old TS version, without update or installing pollyfil it will cause errors
  // eslint-disable-next-line
  const tabId = useRef<string>((window as any).crypto.randomUUID());

  const { emitMessage } = useBroadcastMessage<MessagesReadSyncEvent>({ channelName: MessagesReadSyncId });

  const onAnotherTabWaitingMessagesStatusChange = useCallback(
    (data: MessagesReadSyncEvent) => {
      if (tabId.current !== data.tabId) {
        dispatch(mailboxActions.updateAnyUnreadMessagesFound(false));
      }
    },
    [dispatch],
  );

  useOnBroadcastMessage<MessagesReadSyncEvent>({
    channelName: MessagesReadSyncId,
    callback: onAnotherTabWaitingMessagesStatusChange,
  });

  useEffect(() => {
    if (anyUnreadMessagesFound === false && prevAnyUnreadMessagesFound.current !== anyUnreadMessagesFound) {
      emitMessage({ tabId: tabId.current });
    }
    prevAnyUnreadMessagesFound.current = anyUnreadMessagesFound;
  }, [anyUnreadMessagesFound, emitMessage]);

  return {
    anyUnreadMessagesFound,
  };
};
